import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "count"]
  static values = { max: Number }

  connect() {
    this.update()
  }

  update() {
    const selectedCount = this.optionTargets.filter((option) => option.checked).length
    const limitReached = selectedCount >= this.maxValue

    this.optionTargets.forEach((option) => {
      option.disabled = limitReached && !option.checked
    })
    this.countTarget.textContent = `${selectedCount} / ${this.maxValue}`
  }
}
